function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

const MONTHS_CS = ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"];
const MONTHS_EN = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

function statBox(ctx, x, y, w, label, value, color) {
  ctx.fillStyle = "rgba(24,24,27,0.8)";
  roundRect(ctx, x, y, w, 130, 16);
  ctx.fill();
  ctx.strokeStyle = "rgba(39,39,42,1)";
  ctx.lineWidth = 1.5;
  roundRect(ctx, x, y, w, 130, 16);
  ctx.stroke();
  ctx.textAlign = "center";
  ctx.font = "500 20px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#71717a";
  ctx.fillText(label, x + w / 2, y + 42);
  ctx.font = "700 42px 'JetBrains Mono', monospace";
  ctx.fillStyle = color || "#fafafa";
  ctx.fillText(value, x + w / 2, y + 96);
}

export async function shareGoal({ userName, goal, monthPnl, winRate, trades, lang = "cs" }) {
  const cs = lang === "cs";
  const now = new Date();
  const monthLabel = `${(cs ? MONTHS_CS : MONTHS_EN)[now.getMonth()]} ${now.getFullYear()}`;
  const W = 1080, H = 1080;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");

  ctx.fillStyle = "#09090b";
  ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = "rgba(24,24,27,0.9)";
  ctx.lineWidth = 1;
  for (let x = 0; x <= W; x += 72) { ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, H); ctx.stroke(); }
  for (let y = 0; y <= H; y += 72) { ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(W, y); ctx.stroke(); }
  ctx.fillStyle = "#d4a017";
  ctx.fillRect(0, 0, W, 10);

  await new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      ctx.save();
      roundRect(ctx, 70, 60, 64, 64, 12);
      ctx.clip();
      ctx.drawImage(img, 70, 60, 64, 64);
      ctx.restore();
      resolve();
    };
    img.onerror = () => {
      ctx.fillStyle = "#d4a017";
      roundRect(ctx, 70, 60, 64, 64, 12);
      ctx.fill();
      resolve();
    };
    img.src = "/icons/icon-192.png";
  });
  ctx.textBaseline = "middle";
  ctx.textAlign = "left";
  ctx.font = "700 44px 'Outfit', Arial, sans-serif";
  ctx.fillStyle = "#fafafa";
  ctx.fillText("TradeMind", 155, 92);
  const tw = ctx.measureText("TradeMind ").width;
  ctx.fillStyle = "#e3b341";
  ctx.fillText("AI", 155 + tw, 92);
  ctx.font = "500 22px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#71717a";
  ctx.textAlign = "right";
  ctx.fillText(monthLabel.toUpperCase(), W - 70, 92);

  // Trophy banner
  ctx.textAlign = "center";
  ctx.fillStyle = "rgba(227,179,65,0.10)";
  roundRect(ctx, 70, 200, W - 140, 300, 24);
  ctx.fill();
  ctx.strokeStyle = "rgba(227,179,65,0.45)";
  ctx.lineWidth = 2.5;
  roundRect(ctx, 70, 200, W - 140, 300, 24);
  ctx.stroke();
  ctx.font = "700 58px 'Outfit', Arial, sans-serif";
  ctx.fillStyle = "#e3b341";
  ctx.fillText(cs ? "🏆 MĚSÍČNÍ CÍL SPLNĚN" : "🏆 MONTHLY GOAL ACHIEVED", W / 2, 290);
  ctx.font = "700 110px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#22c55e";
  ctx.fillText(`+$${Math.abs(monthPnl).toLocaleString("en-US", { maximumFractionDigits: 0 })}`, W / 2, 400);
  ctx.font = "500 28px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#a1a1aa";
  ctx.fillText(cs ? `Cíl: $${goal.toLocaleString("en-US", { maximumFractionDigits: 0 })}` : `Goal: $${goal.toLocaleString("en-US", { maximumFractionDigits: 0 })}`, W / 2, 460);

  // Trader name
  ctx.font = "600 40px 'Outfit', Arial, sans-serif";
  ctx.fillStyle = "#fafafa";
  ctx.fillText(userName || "Trader", W / 2, 580);
  ctx.font = "500 22px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#71717a";
  ctx.fillText(cs ? "TRADER MĚSÍCE VE SVÉM DENÍKU" : "OWNED THE MONTH IN THE JOURNAL", W / 2, 625);

  // Stat boxes
  const gap = 24;
  const bw = (W - 140 - gap * 2) / 3;
  statBox(ctx, 70, 700, bw, "WIN RATE", `${winRate}%`, winRate >= 50 ? "#22c55e" : "#f59e0b");
  statBox(ctx, 70 + bw + gap, 700, bw, cs ? "ZISK / ZTRÁTA" : "PROFIT / LOSS", `${monthPnl >= 0 ? "+" : "−"}$${Math.abs(monthPnl).toLocaleString("en-US", { maximumFractionDigits: 0 })}`, monthPnl >= 0 ? "#22c55e" : "#ef4444");
  statBox(ctx, 70 + (bw + gap) * 2, 700, bw, cs ? "OBCHODY" : "TRADES", String(trades));

  // Footer
  ctx.strokeStyle = "rgba(39,39,42,1)";
  ctx.beginPath();
  ctx.moveTo(70, 950);
  ctx.lineTo(W - 70, 950);
  ctx.stroke();
  ctx.textAlign = "left";
  ctx.font = "700 30px 'Outfit', Arial, sans-serif";
  ctx.fillStyle = "#e3b341";
  ctx.fillText("trademind.cz", 70, 1005);
  ctx.textAlign = "right";
  ctx.font = "600 24px 'Outfit', Arial, sans-serif";
  ctx.fillStyle = "#fafafa";
  ctx.fillText(cs ? "Přidej se zdarma → trademind.cz" : "Join free → trademind.cz", W - 70, 1005);
  ctx.textAlign = "left";
  ctx.font = "400 19px Arial, sans-serif";
  ctx.fillStyle = "#52525b";
  ctx.fillText(cs ? "Deník vedený s AI asistentem TradeMind. Nejedná se o investiční doporučení." : "Journal powered by TradeMind AI. Not financial advice.", 70, 1040);

  const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
  const file = new File([blob], `trademind-cil-${now.getFullYear()}-${now.getMonth() + 1}.png`, { type: "image/png" });
  const text = cs
    ? `Měsíční cíl splněn! ${monthLabel}: +$${Math.abs(monthPnl).toLocaleString("en-US", { maximumFractionDigits: 0 })}, win rate ${winRate} % — TradeMind AI\n\nPřidej se zdarma: https://trademind.cz`
    : `Monthly goal achieved! ${monthLabel}: +$${Math.abs(monthPnl).toLocaleString("en-US", { maximumFractionDigits: 0 })}, ${winRate}% win rate — TradeMind AI\n\nJoin free: https://trademind.cz`;
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    await navigator.share({ files: [file], title: "TradeMind AI", text, url: "https://trademind.cz" });
    return "shared";
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = file.name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return "downloaded";
}
